"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tipTapContentToText = exports.getProsemirrorNode = exports.getDataRoot = exports.getFragmentsRoot = exports.getJSONFromFragment = exports.isLayoutPinComponentChanged = exports.getPinComponentFragment = exports.moveTipTapContentToFragments = exports.copyTipTapFragmentToPins = exports.copyTipTapFragmentToComponents = exports.deletePinComponentFragments = exports.deletePinFragments = void 0;
const pins_shared_1 = require("@lessonup/pins-shared");
const yjs_1 = require("yjs");
const y_prosemirror_1 = require("y-prosemirror");
const lodash_1 = require("lodash");
const prosemirror_model_1 = require("prosemirror-model");
const deletePinFragments = (yDoc, pin) => {
    const pinsMap = getFragmentsRoot(yDoc);
    pinsMap.delete(pin.id);
};
exports.deletePinFragments = deletePinFragments;
function deletePinComponentFragments(yDoc, pinId, pinComponentIds) {
    const pinsMap = getFragmentsRoot(yDoc);
    const pinComponentsMap = pinsMap.get(pinId);
    if (!pinComponentsMap) {
        return;
    }
    for (const pinComponentId of pinComponentIds) {
        pinComponentsMap.delete(pinComponentId);
    }
}
exports.deletePinComponentFragments = deletePinComponentFragments;
/**
 * Mutates the pinComponents by setting the tipTapContent to the JSON representation of the fragment
 */
function copyTipTapFragmentToComponents(yDoc, pinId, pinComponents) {
    pinComponents.forEach((pinComponent) => {
        (0, pins_shared_1.processPinComponentTipTapFields)(pinComponent, ({ componentId, fragmentKey }) => {
            return getJSONFromFragment(yDoc, pinId, componentId, fragmentKey);
        });
    });
}
exports.copyTipTapFragmentToComponents = copyTipTapFragmentToComponents;
/**
 * Mutates the pins and pinComponents by setting the tipTapContent to the JSON representation of the fragment
 */
function copyTipTapFragmentToPins(yDoc, pins) {
    pins.forEach((pin) => {
        (0, pins_shared_1.processPinTipTapFields)(pin, ({ componentId, fragmentKey }) => {
            return getJSONFromFragment(yDoc, pin.id, componentId, fragmentKey);
        });
    });
}
exports.copyTipTapFragmentToPins = copyTipTapFragmentToPins;
/**
 * Mutates the yDoc by setting the fragment to the JSON representation of the tipTapContent
 */
function moveTipTapContentToFragments(yDoc, pin) {
    (0, pins_shared_1.processPinTipTapFields)(pin, ({ tipTapContent, componentId, fragmentKey }) => {
        if (tipTapContent !== undefined) {
            const fragment = getOrCreatePinComponentFragment(yDoc, pin.id, componentId, fragmentKey);
            (0, y_prosemirror_1.prosemirrorJSONToYXmlFragment)(pins_shared_1.tipTapSchema, tipTapContent, fragment);
        }
    });
}
exports.moveTipTapContentToFragments = moveTipTapContentToFragments;
function getOrCreatePinComponentFragment(yDoc, pinId, pinComponentId, fragmentKey = 'f0') {
    return (getPinComponentFragment(yDoc, pinId, pinComponentId, fragmentKey) ??
        createPinComponentFragment(yDoc, pinId, pinComponentId, fragmentKey));
}
function createPinComponentFragment(yDoc, pinId, pinComponentId, fragmentKey = 'f0') {
    const pinsMap = getFragmentsRoot(yDoc);
    const componentsMap = pinsMap.get(pinId) || pinsMap.set(pinId, new yjs_1.Map());
    const fragmentsMap = componentsMap.get(pinComponentId) || componentsMap.set(pinComponentId, new yjs_1.Map());
    return fragmentsMap.get(fragmentKey) || fragmentsMap.set(fragmentKey, new yjs_1.XmlFragment());
}
/**
 * Fragment is nested 3 levels deep in yDoc: yDoc -> fragments (Map) -> pinId (Map) -> pinComponentId (Map) -> fragmentKey (XmlFragment)
 * fragmentKey exists for future-proofing support multiple fragments per pinComponentId (e.g. multiple text pin components)
 */
function getPinComponentFragment(yDoc, pinId, pinComponentId, fragmentKey = 'f0') {
    const pinsMap = getFragmentsRoot(yDoc);
    const componentsMap = pinsMap.get(pinId);
    const fragmentsMap = componentsMap?.get(pinComponentId);
    return fragmentsMap?.get(fragmentKey) || null;
}
exports.getPinComponentFragment = getPinComponentFragment;
function isLayoutPinComponentChanged(yDoc, pinId, layoutPinComponent, pinComponent) {
    if ((0, pins_shared_1.isTextPinComponent)(layoutPinComponent) && (0, pins_shared_1.isTextPinComponent)(pinComponent)) {
        const currentJSon = getJSONFromFragment(yDoc, pinId, pinComponent.id);
        return !(0, lodash_1.isEqual)(currentJSon, layoutPinComponent.settings.tipTapContent);
    }
    return !(0, lodash_1.isEqual)(pinComponent.layout, layoutPinComponent.layout);
}
exports.isLayoutPinComponentChanged = isLayoutPinComponentChanged;
function getJSONFromFragment(yDoc, pinId, pinComponentId, fragmentKey = 'f0') {
    const fragment = getPinComponentFragment(yDoc, pinId, pinComponentId, fragmentKey) ?? new yjs_1.XmlFragment();
    return (0, y_prosemirror_1.yXmlFragmentToProsemirrorJSON)(fragment);
}
exports.getJSONFromFragment = getJSONFromFragment;
function getFragmentsRoot(yDoc) {
    return yDoc.getMap('fragments');
}
exports.getFragmentsRoot = getFragmentsRoot;
function getDataRoot(yDoc) {
    return yDoc.getMap('data');
}
exports.getDataRoot = getDataRoot;
function getProsemirrorNode(jsonState) {
    return prosemirror_model_1.Node.fromJSON(pins_shared_1.tipTapSchema, jsonState);
}
exports.getProsemirrorNode = getProsemirrorNode;
function tipTapContentToText(jsonState) {
    const doc = getProsemirrorNode(jsonState);
    return doc.textBetween(0, doc.content.size, '\n');
}
exports.tipTapContentToText = tipTapContentToText;
//# sourceMappingURL=y-doc-fragment-helpers.js.map